import React from 'react'
import { Container, Paper, Button, Typography, Box } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2'
import { useUrlSearchParams } from '../hooks/useUrlSearchParams'
import { useNav } from '../hooks/useNav'
import PageFooter from '../components/PageFooter.js'
import { Item } from '../components/Item.js'
import CorrectCopyright from '../components/CorrectCopyright.js'
import appUtilities from '../utilities/appUtilities.js'

export default function GglChoice() {
    const [, , sessionObj] = useUrlSearchParams()
    const [, pgNav] = useNav(sessionObj)

    function handlePgNav(direction) {
        pgNav(direction)
    }

    return (
        // This Box makes the magic happen
        <Box
            sx={{
                minHeight: '100vh', // Full viewport height
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Main content — grows but doesn't push footer down if too short */}
            <Box sx={{ flexGrow: 1, display: 'flex' }}>
                <Container
                    maxWidth="md"
                    sx={{
                        marginTop: { xs: 4, md: 8 },
                        marginBottom: { xs: 4, md: 8 }, // optional: breathing room
                    }}
                >
                    <Paper elevation={22}>
                        <Grid2
                            container
                            spacing={2}
                            sx={{ minHeight: '24rem' }}
                        >
                            {/* Your existing content */}
                            <Grid2 xs={12}>
                                <Item elevation={0}>
                                    <Typography
                                        align="right"
                                        variant="h6"
                                        paddingRight={2}
                                    >
                                        Fence Dimensions
                                    </Typography>
                                </Item>
                            </Grid2>

                            <Grid2 container xs={12}>
                                <Grid2
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            handlePgNav(
                                                appUtilities.navDirections.next
                                            )
                                        }
                                    >
                                        ENTER FENCE DETAILS
                                    </Button>
                                </Grid2>

                                <Grid2
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            handlePgNav(
                                                appUtilities.navDirections
                                                    .google
                                            )
                                        }
                                    >
                                        GET HELP WITH SATELLITE MAP
                                    </Button>
                                </Grid2>
                            </Grid2>

                            <Grid2 xs={12} sx={{ mt: 3, mb: 5, mx: 6 }}>
                                <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{ mb: 6 }}
                                >
                                    <CorrectCopyright
                                        copyrightTextValue={`This fence planning program will walk you through
                    the process of planning your ElectroBraid® Fence 
                    step-by-step and provide a list of materials to build a complete system.`}
                                    />
                                </Typography>
                                <Typography variant="subtitle1" align="center">
                                    <CorrectCopyright
                                        copyrightTextValue={`Thank you for choosing ElectroBraid® Fence - America's #1
                    Electric Horse Fence.`}
                                    />
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Paper>
                </Container>
            </Box>

            {/* Footer — always sticks to bottom */}
            <Box
                component="footer"
                sx={{
                    flexShrink: 0, // Never shrink
                    mt: 'auto', // Pushes it to bottom
                }}
            >
                <PageFooter />
            </Box>
        </Box>
    )
}
